import log from 'salvo-lite/log'
import AjaxAPI from '../helpers/AjaxAPI'

class Product {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components
        this._addButton = document.querySelector('[data-add-to-cart]')
        this._addButtonJSON = this._addButton ? JSON.parse(this._addButton.getAttribute('data-add-to-cart') || '{}') : '{}'
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        document.addEventListener('click', e => e.target.hasAttribute('data-add-to-cart') && this._addToCart(e))
    }

    async _addToCart (e) {
        e.preventDefault()
        const quantity = parseInt(document.querySelector('[data-product-quantity]').value)
        const selectedVariantID = parseInt(document.querySelector('[data-product-selected-variant]').value)
        const currentItemPayload = {quantity, id: selectedVariantID, properties: {}}
        let payload = []
        payload.push(currentItemPayload)

        if (this._addButtonJSON.freeGiftProductID) {
            payload.push(
                {
                    quantity: 1,
                    id: parseInt(this._addButtonJSON.freeGiftProductID),
                    properties: {
                        'Free Gift Parent': selectedVariantID,
                        'linked-free-product': 1
                    }
                }
            )

            // Add the ID of the free gift to the main product
            payload[0].properties = {
                'Free Gift': this._addButtonJSON.freeGiftProductID
            }
        }

        await AjaxAPI.addItem({ items: payload })
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Product.js